import React from 'react'
import Component from '../common/Component'
import BenefitsSetBulkEditsComponent from '../BenefitsSet/BenefitsSetBulkEditsComponent'
import { benefitLabels, coverageTierLabels, deductibleMoopLabels, metadatumFieldsDiffSet } from './dentalFields'

const defaultFields = {
  default: {
    values: [
      'hios_ids',
      'id',
      'vericred_id',
      'name',
      'audience',
      'plan_type',
      'issuer_name',
      'stand_alone',
      'voluntary',
      'ortho',
      'effective_date',
      'expiration_date',
      'copay_schedule',
      'out_of_network_reimbursement_type',
      'usual_customary_reasonable_percentile'
    ],
    pinned: ['id', 'vericred_id', 'sbc_url', 'sob_url']
  }
}

export default class DentalBenefitsSetBulkEditsComponent extends Component {
  render() {
    return (
      <BenefitsSetBulkEditsComponent
        benefitLabels={({ ...benefitLabels, ...coverageTierLabels, ...deductibleMoopLabels })}
        benefitLabelsWithoutCoverageTier={({ ...coverageTierLabels, ...deductibleMoopLabels })}
        metadatumFields={metadatumFieldsDiffSet}
        defaultFields={defaultFields}
        benefitsSetUrl="/dental_benefits"
        productLine="dental"
        includeSbcCheckbox
        sbcCheckboxLabel="Build from Benefit Summaries"
        hideSobUrl
        {...this.props}
      />
    )
  }
}
